import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';//vuex持久化
import userStore from './modules/userStore';

Vue.use(Vuex);

/**
 * [模块化状态管理]
 * @type {Object}
 */
export default new Vuex.Store({
    modules:{
        userStore
    },
    plugins: [createPersistedState()],
});


// WEBPACK FOOTER //
// ./src/store/store.js